import React from "react";
import { Form, Col, Button, Spinner } from "react-bootstrap";
import { Auth, Hub } from "aws-amplify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { strengthIndicator, strengthColor } from "./strength-password";
import zxcvbn from "zxcvbn";
import { ToastCluster, ToastMessage } from "@skf/bt-wind-rail-commonlibrary";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      newpassword: "",
      currentpassword: "",
      confirmPassword: "",
      submitted: false,
      validated: false,
      stateSesion: "",
      changePassword: false,
      forgotPassword: false,
      newPassword: false,
      typeLogin: 0,
      error: false,
      login: false,
      matchingPasswords: true,
      passwordErrorPolicy: false,
      passwordErrorPolicyMessage: "",
      toastMessage: undefined,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    this.setState({ validated: true });
    const { dispatch } = this.props;
    if (username && password) {
      this.loginCognito(username, password);
    }
  };

  handleSubmitPsw = (e) => {
    console.log("handleSubmitPsw");
    this.setState({ submitted: true });
    Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(
          user,
          this.state.currentpassword,
          this.state.newpassword
        );
      })
      .then((data) => {
        this.setState({ changePassword: false, error: false });
        window.location.replace(process.env.REACT_APP_FRONT_URL);
      })
      .catch((err) => {
        console.log(err);
        if (
          err.mensaje == "Attempt limit exceeded, please try after some time."
        )
          this.setState({ error: true, errmessage: err.mensaje });
        if (err.mensaje == "Incorrect username or password")
          this.setState({ error: true, errmessage: err.mensaje });
      });
  };

  completeNewPassword = () => {
    console.log(this.state);
    this.setState({ submitted: true });
    if (
      !this.state.password ||
      !this.state.username ||
      !this.state.newpassword ||
      !this.state.confirmPassword
    )
      return;
    if (this.state.newpassword !== this.state.confirmPassword) {
      this.setState({ matchingPasswords: false });
      return;
    }
    Auth.signIn(this.state.username, this.state.password)
      .then((user) => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          Auth.completeNewPassword(
            user, // the Cognito User Object
            this.state.confirmPassword // the new password
          )
            .then((user) => {
              console.log("user log ", user);
            })
            .catch((e) => {
              console.log("mi ex:", e);
              this.setState({
                passwordErrorPolicy: true,
                passwordErrorPolicyMessage: e.message,
              });
              return;
            });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  handleSubmitForgotPsw = (e) => {
    Auth.forgotPasswordSubmit(
      this.state.username,
      this.state.code,
      this.state.newpassword
    )
      .then((data) => {
        this.setState({ forgotPassword: false });
      })
      .catch((err) => console.log(err));
  };

  cleanTokens = () => {
    localStorage.setItem("cognito:windIdToken", "");
    localStorage.setItem("cognito:portalIdToken", "");
    localStorage.setItem("cognito:railIdToken", "");
  };

  componentDidMount() {
    if (window.location.href.includes("logout=true")) {
      this.logoutCognito();
      window.location.replace(process.env.REACT_APP_LOGIN_URL);
    }

    if (window.location.href.includes("changePsw=true")) {
      this.setState({ changePassword: true });
    }

    // Auth.signOut({ global: true });
    var intervalId = window.setInterval(() => {
      this.stateSesion();
    }, 1000);

    window.onbeforeunload = function (e) {
      sessionStorage.setItem("loggedIn", false);
      sessionStorage.setItem("idToken", "");
      sessionStorage.setItem("tokenType", "");
      sessionStorage.setItem("refreshToken", "");
      sessionStorage.setItem("username", "");
      sessionStorage.setItem("expiresIn", "");
      //  document.cookie = "tokenSKF=" + "";
    };

    const queryString = window.location.href;

    Hub.listen("auth", ({ payload: { event, data } }) => {
      console.log("event", event, data);
      if (event == "signIn") {
        if (data.signInUserSession.idToken.jwtToken) {
          sessionStorage.setItem("loggedIn", true);
          const expiresIn = moment.unix(
            data.signInUserSession.idToken.payload.exp
          );
          var token = data.signInUserSession.idToken.jwtToken;
          let url = process.env.REACT_APP_FRONT_URL + "/#id_token=" + token;

          window.location.href = url;
        }
      }
    });
  }

  componentWillUnmount() {
    sessionStorage.setItem("loggedIn", false);
    sessionStorage.setItem("idToken", "");
    sessionStorage.setItem("tokenType", "");
    sessionStorage.setItem("refreshToken", "");
    sessionStorage.setItem("username", "");
    sessionStorage.setItem("expiresIn", "");
    document.cookie = "tokenSKF=" + "";
  }

  loginCognito = async (username, password) => {
    this.setState({ login: true });
    let loginResul = undefined;
    try {
      loginResul = await Auth.signIn(username, password);
      if (loginResul?.signInUserSession?.idToken.jwtToken) {
        sessionStorage.setItem("loggedIn", true);
        sessionStorage.setItem(
          "idToken",
          loginResul.signInUserSession.idToken.jwtToken
        );
        const expiresIn = moment.unix(
          loginResul.signInUserSession.idToken.payload.exp
        );
        console.log(expiresIn);
        sessionStorage.setItem("expiresIn", expiresIn);
        sessionStorage.setItem("username", username);
        sessionStorage.setItem("password", password);
        sessionStorage.setItem("SKF", false);
        this.setState({ username, password });
      } else {
        if (loginResul?.challengeName) {
          this.setState({ newPassword: true });
        }
      }
    } catch (error) {
      this.setState({
        error: true,
        errMessage: "User or password are incorrect.",
      });
      this.setState({ login: false });
    }
  };

  logoutCognito = async () => {
    // await Auth.signOut();
    this.handleLogout();
  };

  refreshCognito = async () => {
    try {
      console.log(sessionStorage.getItem("SKF"));
      let username = sessionStorage.getItem("username");
      let password = sessionStorage.getItem("password");
      let loginResul = await Auth.signIn(username, password);
      if (loginResul.signInUserSession.idToken.jwtToken) {
        sessionStorage.setItem("loggedIn", true);
        localStorage.setItem(
          "idToken",
          loginResul.signInUserSession.idToken.jwtToken
        );
        const expiresIn = moment.unix(
          loginResul.signInUserSession.idToken.payload.exp
        );
        sessionStorage.setItem("expiresIn", expiresIn);
      }
    } catch (error) {
      console.log("error login aws");
      console.log("error signing in", error);
    }
  };

  stateSesion = () => {
    if (Date.now() < new Date(sessionStorage.getItem("expiresIn")).getTime()) {
      if (this.state.stateSesion !== "Active session")
        this.setState({ stateSesion: "Active session" });
    } else if (this.state.stateSesion !== "Expired Session")
      this.setState({ stateSesion: "Expired Session" });
  };

  handleLogout = () => {
    sessionStorage.setItem("loggedIn", false);
    sessionStorage.setItem("idToken", "");
    sessionStorage.setItem("tokenType", "");
    sessionStorage.setItem("refreshToken", "");
    sessionStorage.setItem("username", "");
    sessionStorage.setItem("expiresIn", "");
    document.cookie = "tokenSKF=" + "";
    this.cleanTokens();
    this.forceUpdate();
  };

  handleChangePsw = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value, strength: zxcvbn(value).score });
    this.setState({
      passwordErrorPolicy: false,
      passwordErrorPolicyMessage: "",
      matchingPasswords: true,
    });

    if (name === "password") {
      // check password
      const strength = strengthIndicator(value);
      const color = strengthColor(strength);
    }
  };

  renderChangePassword() {
    const { sending } = this.props;
    const {
      currentpassword,
      newpassword,
      confirmPassword,
      submitted,
      matchingPasswords,
      error,
      strength,
      passwordErrorPolicy,
      passwordErrorPolicyMessage,
    } = this.state;

    const passwordLength = newpassword.length;
    const passwordStrong = strength >= this.minStrength;
    const passwordLong = passwordLength > this.thresholdLength;
    const counterClass = [
      "badge badge-pill",
      passwordLong
        ? passwordStrong
          ? "badge-success"
          : "badge-warning"
        : "badge-danger",
    ]
      .join(" ")
      .trim();

    // password strength meter is only visible when password is not empty
    const strengthClass = [
      "strength-meter mt-2",
      passwordLength > 0 ? "visible" : "invisible",
    ]
      .join(" ")
      .trim();

    return (
      <div>
        <div className="logo" />
        <div className="full authBG">
          <div className="loginBox">
            <div className="full">
              <div className="centerBox">
                <span className="SKFH1">Change Password</span>
                <br></br>
                <br></br>
                <div
                  className={
                    "form-group " +
                    (submitted && !newpassword ? " has-error" : "")
                  }
                >
                  <input
                    type="password"
                    className="form-control inputlogin"
                    placeholder="Current password"
                    name="currentpassword"
                    value={currentpassword}
                    onChange={this.handleChangePsw}
                  />

                  {submitted && !currentpassword && (
                    <div className="help-block errortext">
                      Current password is required.
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group " +
                    (submitted && !newpassword ? " has-error" : "")
                  }
                >
                  <input
                    type="password"
                    className="form-control inputlogin"
                    placeholder="New password"
                    name="newpassword"
                    value={newpassword}
                    onChange={this.handleChangePsw}
                  />
                  {submitted && !newpassword && (
                    <div className="help-block errortext">
                      Password is required.
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group" +
                    (submitted && !confirmPassword ? " has-error" : "")
                  }
                >
                  <input
                    type="password"
                    className="form-control inputlogin"
                    placeholder="Confirm new password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={this.handleChangePsw}
                  />
                  {submitted && !confirmPassword && (
                    <div className="help-block errortext">
                      Password needs to be confirmed.
                    </div>
                  )}
                </div>
                Password strength
                <div className={strengthClass}>
                  <div
                    className="strength-meter-fill"
                    data-strength={strength}
                  ></div>
                </div>
                {submitted &&
                  newpassword &&
                  confirmPassword &&
                  !(newpassword == confirmPassword) && (
                    <div className="help-block errortext">
                      Passwords need to match.
                    </div>
                  )}
                {submitted &&
                  newpassword &&
                  confirmPassword &&
                  !passwordErrorPolicy && (
                    <div className="help-block errortext">
                      {passwordErrorPolicyMessage}
                    </div>
                  )}
                {submitted &&
                  newpassword &&
                  confirmPassword &&
                  !(newpassword.length > 6) &&
                  !(confirmPassword.length > 6) && (
                    <div className="help-block">
                      Passwords must have length greater than or equal to 6 .
                    </div>
                  )}
                {submitted &&
                  error &&
                  newpassword.length > 6 &&
                  confirmPassword.length > 6 && (
                    <div className="help-block">Old passwords incorrect .</div>
                  )}
                <div className="form-group centerText customMargin">
                  <button
                    className="btn btn-primary button-change-password"
                    onClick={() => this.handleSubmitPsw()}
                  >
                    Change password{" "}
                  </button>

                  <button
                    style={{ marginLeft: 20 }}
                    className="btn btn-primary button-change-password"
                    onClick={() => {
                      this.setState({ changePassword: false });
                      window.history.back();
                    }}
                  >
                    Back{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  sendEmail = () => {
    Auth.forgotPassword(this.state.username)
      .then((data) => {
        this.setState({
          toastMessage: { message: "Forgot password email sent", status: "ok" },
        });
        console.log(data);
      })
      .catch((err) => {
        this.setState({
          toastMessage: {
            message: "Error sending forgot password email",
            status: "warning",
          },
        });
        console.log(err);
      });
  };

  renderForgotPassword() {
    const { sending } = this.props;
    const {
      username,
      newpassword,
      confirmPassword,
      submitted,
      matchingPasswords,
      strength,
      code,
      passwordErrorPolicy,
      passwordErrorPolicyMessage,
    } = this.state;

    const passwordLength = newpassword.length;
    const passwordStrong = strength >= this.minStrength;
    const passwordLong = passwordLength > this.thresholdLength;
    const counterClass = [
      "badge badge-pill",
      passwordLong
        ? passwordStrong
          ? "badge-success"
          : "badge-warning"
        : "badge-danger",
    ]
      .join(" ")
      .trim();

    // password strength meter is only visible when password is not empty
    const strengthClass = [
      "strength-meter mt-2",
      passwordLength > 0 ? "visible" : "invisible",
    ]
      .join(" ")
      .trim();

    return (
      <div>
        <ToastCluster toastMessage={this.state.toastMessage} />
        <div className="logo" />
        <div className="full authBG">
          <div className="forgetBox">
            <div className="full">
              <div className="centerBox">
                <span className="SKFH1">
                  {" "}
                  {this.state.newPassword
                    ? "Password change"
                    : "Forgot Password"}{" "}
                </span>
                <br></br>
                <br></br>
                <div
                  className={
                    "form-group " +
                    (submitted && !newpassword ? " has-error" : "")
                  }
                >
                  <input
                    style={
                      this.state.forgotPassword
                        ? { width: "60%", float: "left" }
                        : {}
                    }
                    type="text"
                    className="form-control inputlogin"
                    placeholder="Username"
                    id="Username"
                    name="username"
                    value={username}
                    onChange={this.handleChangePsw}
                  />
                  {this.state.forgotPassword && (
                    <button
                      style={{ width: "30%", float: "left", marginTop: 10 }}
                      className="btn btn-primary button-change-password"
                      onClick={() => this.sendEmail()}
                    >
                      Send email
                    </button>
                  )}
                  {submitted && !username && (
                    <div className="help-block errortext">
                      Current Username is required.
                    </div>
                  )}
                  {this.state.forgotPassword && (
                    <div>
                      {" "}
                      <br></br>
                      <br></br>
                      <br></br>
                      <input
                        type="text"
                        className="form-control inputlogin"
                        placeholder="Code email"
                        name="code"
                        id="code"
                        value={code}
                        onChange={this.handleChangePsw}
                      />
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group " +
                    (submitted && !newpassword ? " has-error" : "")
                  }
                >
                  <input
                    type="password"
                    className="form-control inputlogin"
                    placeholder="New password"
                    name="newpassword"
                    value={newpassword}
                    onChange={this.handleChangePsw}
                  />
                  {submitted && !newpassword && (
                    <div className="help-block errortext">
                      Password is required.
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group" +
                    (submitted && !confirmPassword ? " has-error" : "")
                  }
                >
                  <input
                    type="password"
                    className="form-control inputlogin"
                    placeholder="Confirm new password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={this.handleChangePsw}
                  />
                  {submitted && !confirmPassword && (
                    <div className="help-block errortext">
                      Password needs to be confirmed.
                    </div>
                  )}
                </div>
                Password strength
                <div className={strengthClass}>
                  <div
                    className="strength-meter-fill"
                    data-strength={strength}
                  ></div>
                </div>
                {submitted &&
                  newpassword &&
                  confirmPassword &&
                  !matchingPasswords && (
                    <div className="help-block errortext">
                      Passwords need to match.
                    </div>
                  )}
                {submitted &&
                  newpassword &&
                  confirmPassword &&
                  passwordErrorPolicy && (
                    <div className="help-block errortext">
                      {passwordErrorPolicyMessage}
                    </div>
                  )}
                <div className="form-group centerText customMargin">
                  <button
                    className="btn btn-primary button-change-password"
                    onClick={
                      this.state.forgotPassword
                        ? this.handleSubmitForgotPsw
                        : this.completeNewPassword
                    }
                  >
                    Change password{" "}
                  </button>

                  <button
                    style={{ marginLeft: 20 }}
                    className="btn btn-primary button-change-password"
                    onClick={() =>
                      this.setState({
                        forgotPassword: false,
                        newPassword: false,
                        login: false,
                      })
                    }
                  >
                    Back{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLogin() {
    const { loginState } = this.props;
    const { alert } = this.props;

    const { submitted, validated } = this.state;
    const lsloggedin = sessionStorage.getItem("loggedIn");
    const lsidToken = localStorage.getItem("idToken");
    let isLoggedIn = lsidToken && lsloggedin;
    return (
      <div>
        <div className="logo" />
        <div className="full authBG">
          <div className="loginBox">
            <div className="SKFH1">
              Welcome to SKF Servitization Digitalization
            </div>
            {isLoggedIn ? (
              <div>
                <br></br>
                <div>
                  You are already logged in as:{" "}
                  <span className="SKFH3">
                    {sessionStorage.getItem("username")}
                  </span>{" "}
                </div>
                <div>
                  Sesion:{" "}
                  <span className="SKFH3">{this.state.stateSesion}</span>{" "}
                </div>{" "}
                <br></br>
                <br></br>
                <Button
                  type="submit"
                  className="btn btn-primary buttonlogin"
                  onClick={this.handleLogout}
                >
                  Logout{" "}
                  {loginState && <FontAwesomeIcon icon={faSpinner} spin />}
                </Button>
                <br></br>
                <br></br>
                {this.state.stateSesion == "Expired Session" ? (
                  <Button
                    type="submit"
                    className="btn btn-primary buttonlogin"
                    onClick={this.refreshCognito}
                  >
                    Refresh Log In{" "}
                    {loginState && <FontAwesomeIcon icon={faSpinner} spin />}
                  </Button>
                ) : (
                  <div />
                )}
              </div>
            ) : (
              <Form
                noValidate
                validated={validated}
                onSubmit={(e) => this.handleSubmit(e)}
              >
                <Form.Row>
                  <Form.Group as={Col} controlId="validationCustom01">
                    <Form.Label className="fontMin noMarginBottom customMargin">
                      {" "}
                      Username{" "}
                    </Form.Label>
                    <Form.Control
                      className="form-control inputlogin"
                      required
                      type="text"
                      name="username"
                      value={this.state.username}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      Username is required{" "}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="validationCustom01">
                    <Form.Label className="fontMin noMarginBottom">
                      {" "}
                      Password{" "}
                    </Form.Label>
                    <Form.Control
                      className="form-control inputlogin"
                      required
                      value={this.state.password}
                      onChange={this.handleChange}
                      type="password"
                      name="password"
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      Password is required{" "}
                    </Form.Control.Feedback>
                    {submitted && alert && alert.message && (
                      <div className="msgError">{alert.message}</div>
                    )}
                    {this.state.error && (
                      <div className="msgError">{this.state.errMessage}</div>
                    )}
                  </Form.Group>
                </Form.Row>

                <div className="form-group centerText customMargin">
                  <Button
                    type="submit"
                    className="btn btn-primary buttonlogin"
                    disabled={this.state.login}
                  >
                    {this.state.login ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Log in"
                    )}
                    {loginState && <FontAwesomeIcon icon={faSpinner} spin />}
                  </Button>

                  <Button
                    disabled={this.state.login}
                    style={{ marginLeft: 20 }}
                    className="btn btn-primary buttonlogin"
                    onClick={async () => {
                      let result = await Auth.federatedSignIn({
                        customProvider: "SKF",
                      });
                    }}
                  >
                    {this.state.login ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "  SKF log in"
                    )}
                    {loginState && <FontAwesomeIcon icon={faSpinner} spin />}
                  </Button>
                </div>

                <div className="centerText">
                  <span
                    className="fontMin cursorPointer"
                    onClick={() => this.setState({ forgotPassword: true })}
                  >
                    Forgot your password?
                  </span>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (
      !this.state.changePassword &&
      !this.state.forgotPassword &&
      !this.state.newPassword
    )
      return this.renderLogin();
    else if (this.state.changePassword) return this.renderChangePassword();
    else return this.renderForgotPassword();
  }
}

export default LoginPage;
